exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".green-text[data-v-787c48dd] {\n  color: #209431;\n}\n.modal-trigger[data-v-787c48dd] {\n  cursor: pointer;\n}\n#mileageAndDurationModal .modal-dialog[data-v-787c48dd],\n#mileageAndDurationModal .modal-content[data-v-787c48dd] {\n  height: 80%;\n}\n#mileageAndDurationModal .modal-body[data-v-787c48dd] {\n  max-height: 100%;\n  overflow-y: scroll;\n}\nh3[data-v-787c48dd] {\n  font-style: normal;\n  font-weight: 700 !important;\n  font-size: 1.09rem !important;\n  margin-bottom: 0.5rem;\n}\np[data-v-787c48dd] {\n  text-align: start !important;\n  line-height: 1.3;\n}", ""]);

// exports
